<template>
  <div>
    <nav-breadcrumb :menu="[{label: '转账还款复核'}]"/>
    <el-row>
      <el-col class=" bg-purple">
        <el-tabs v-model="applicationStatus">
          <el-tab-pane label="未复核" name="Pending Approval" />
          <!-- <el-tab-pane label="审核通过" name="Approved" />-->
          <el-tab-pane label="已复核" name="Rejected" />
        </el-tabs>
        <data-table
          :table-data="tableData"
          :columns="columns"
          :page.sync="page"
          :pageSize.sync="pageSize"
          :s.sync="filters"
          :actions="actions"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import {removeItem} from "../../filters/CommonActions";
    export default {
        name: "TransferRepaymentFinanceList",
      data(){
        return{
          applicationStatus:'Pending Approval',
          columns:[
            {
              type: 'index'
            },
            {
              label: '收款记录',
              field: 'd__dealerName'
            },
            {
              label: '贷款匹配',
              field: 'd__dealerCode'
            },
            {
              label: '操作',
              opts:[
                {
                  label: '通过',
                  class: 'el-icon-edit',
                  clickHandler: (index, row)=> {

                  }
                },
                {
                  label: '退回',
                  class: 'el-icon-edit',
                  clickHandler: (index, row)=> {

                  }
                },
              ]
            }
          ],
          tableData: {
            count: 0,
            data: []
          },
          dealerTypeOptions:[],
          page: 1,
          pageSize: 20,
          actions: [
            {
              label: '通过',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'add'
                })
              }
            },
            {
              label: '退回',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'add'
                })
              }
            }
          ],
          filters: {
            labelWidth: '150px',
            form: {
              dt__deviceType:'',
            },
            columns: [
              {
                label: '所属银行',
                component: 'el-input',
                field: 'd__dealerCode'
              },
              {
                label: '状态',
                component: 'el-select',
                field: 'dt__dealerTypeId',
                options: this.dealerTypeOptions,
              },
              {
                label: '请选择日期',
                component: 'el-date-picker',
                field: 't__applicationDate',
                span: 14
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      mounted() {
        this.getData()
        this.getDealerType()
      },
      computed: {
        filterParams() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
          /*  'xlist.search.t.applicationStatus' : this.applicationStatus,
            'xlist.search.t.applicationStatus.op' : 'in',*/
          }
        }
      },
      watch: {
        filterParams: function (newVal) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getDealerList(
            Object.assign({pageSize:0}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.tableData = res.data
              }catch(e){

              }
            })

        },
        getDealerType: function () {
          xhr.getDealerType(
            Object.assign({}, {}, {}),
            res=> {
              try {
                this.filters.columns[2].options = res.data.data.map(item=>{
                  return {
                    label: item.dt__name,
                    value:item.dt__dealerTypeId,
                  }
                })
              }catch(e){

              }
            })

        },
        removeItem: function (index, row) {
          removeItem(
            xhr.deleteConfigDepartment,
            {
              'd.departmentId' : row.d__departmentId
            },
            res=>{
              try {
                if(res.data.status == 'success') {
                  this.getConfigDepartmentAsTree()
                  this.getConfigDepartmentList(this.selected.id)
                }
              }catch (e) {

              }
            }
          )
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/TransferRepaymentFinanceList.vue